import { useEffect, useRef, useState } from 'react'
import WhyChoosePanel from './WhyChoosePanel'
import WhyChooseZodiacWheel from './WhyChooseZodiacWheel'

const TABS = ['Who We Are', 'Our Mission', 'Our Vision', 'Begin Your Journey']
const TOTAL = 4

export default function WhyChooseSection() {
  const sectionRef = useRef(null)
  const [current, setCurrent] = useState(0)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    function onScroll() {
      const el = sectionRef.current
      if (!el) return
      const rect = el.getBoundingClientRect()
      const sectionH = el.offsetHeight - window.innerHeight
      const scrolled = Math.max(0, -rect.top)
      const pct = sectionH > 0 ? Math.min(1, scrolled / sectionH) : 0
      setProgress(pct)
      setCurrent(Math.min(TOTAL - 1, Math.floor(pct * TOTAL)))
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const goTo = (idx) => {
    const el = sectionRef.current
    if (!el) return
    const sectionTop = el.getBoundingClientRect().top + window.scrollY
    const sectionH = el.offsetHeight - window.innerHeight
    const targetScroll = sectionTop + (idx / TOTAL) * sectionH + 1
    window.scrollTo({ top: targetScroll, behavior: 'smooth' })
  }

  return (
    <section id="why-choose" ref={sectionRef} className="relative md:px-22" style={{ height: '400vh' }}>
      <div
        id="wcu-sticky"
        className="sticky top-0 flex h-screen items-center overflow-hidden text-white"
        style={{ background: 'radial-gradient(ellipse 160% 90% at 25% 55%,rgba(120,53,15,.22) 0%,rgba(19,14,11,.97) 42%,rgba(11,8,6,1) 76%)' }}
      >
        <div className="pointer-events-none absolute inset-0 opacity-[0.05] bg-[radial-gradient(#E6C878_1px,transparent_1.5px)] bg-size-[26px_26px]" aria-hidden="true" />
        <div className="pointer-events-none absolute -left-32 top-10 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(232,119,15,0.16),transparent_70%)] blur-3xl" aria-hidden="true" />
        <div className="pointer-events-none absolute -right-32 bottom-0 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(122,31,43,0.30),transparent_70%)] blur-3xl" aria-hidden="true" />

        <WhyChooseZodiacWheel mobile />

        <div className="container relative z-10 mx-auto grid grid-cols-1 items-center gap-10 px-6 max-w-350 lg:grid-cols-2 lg:gap-16">
          <div className="relative min-h-[60vh] flex flex-col justify-center text-center lg:text-left">
            {Array.from({ length: TOTAL }, (_, i) => (
              <WhyChoosePanel key={i} index={i} active={i === current} current={current} />
            ))}
          </div>

          <WhyChooseZodiacWheel currentIndex={current} />
        </div>

        <div className="absolute inset-x-0 bottom-0 z-20 px-6 pb-6">
          <div className="mx-auto max-w-350">
            <div className="mb-3 flex items-center justify-between">
              {TABS.map((label, i) => (
                <button
                  key={label}
                  type="button"
                  id={`wcu-tab-${i}`}
                  onClick={() => goTo(i)}
                  className={`flex items-center gap-2 text-[9px] uppercase tracking-[0.25em] transition-colors ${
                    i === current ? 'text-goldPrimary' : 'text-white/35 hover:text-white/60'
                  }`}
                >
                  <span className={`h-1.5 w-1.5 rounded-full transition-all ${i === current ? 'bg-goldPrimary scale-125' : 'bg-white/25'}`} />
                  <span className="hidden sm:inline">{label}</span>
                </button>
              ))}
            </div>
            <div className="h-1 w-full overflow-hidden rounded-full bg-white/10">
              <div
                id="wcu-progress"
                className="h-full origin-left rounded-full bg-linear-to-r from-goldAccent via-amber-200 to-goldAccent"
                style={{ transform: `scaleX(${progress})`, transition: 'transform .1s linear' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
